export default "__VITE_ASSET__O8a_Fj05__"